// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__306iA","item":"PaymentsMobile_item__2ZT6s","label":"PaymentsMobile_label__2xtDF","amount":"PaymentsMobile_amount__2i6Fj"};